module.exports = __webpack_public_path__ + "static/media/g4s.f87a8842.png";